import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-modal-page-header',
  template: '<ng-content> </ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalPageHeaderComponent {}
